import { render } from "./Header.vue?vue&type=template&id=c2b9a784"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"
script.render = render

export default script